module.exports = __webpack_public_path__ + "img/banner-bg2.527de2ef.png";